import R from 'ramda'
import auto from 'async/auto'
import {defineMessages} from 'react-intl'

import {getSummaries} from '../api/search' 

import fetchDirections from './fetchDirections'
import fetchDetails from './fetchDetails'
import addNotification from './addNotification'

import getCurrentQuery from '../utils/getCurrentQuery'

import sortedEstateList from '../selectors/sortedEstateList'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "While selecting this estate, an error occured, try again later", 
    defaultMessage: "While selecting this estate, an error occured, try again later"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

export default (estateId) => (dispatch, getState) => {

  const query = getCurrentQuery()
  const {lastVisibleIndex} = getState()
  const visibleList = R.slice(0, lastVisibleIndex, sortedEstateList(getState())) 
  const estateIsInVisibleList = R.any((estate) => estate.id == estateId, visibleList)
  const summaryIsInCache = R.path(['estates', estateId, 'summary'], getState())
  
  const fetchSummaryIfNeeded = (cb) => {
    if(summaryIsInCache){ return cb() }
    getSummaries([estateId], cb)
  }
  const loadSummary = ({estateSummary}, cb) => {
    if(summaryIsInCache){ return cb() }
    cb(null, dispatch({type: 'load_estates', estates: estateSummary}))
  }
  const addToVisibleListIfNeeded = (results, cb) => {
    if(estateIsInVisibleList){ return cb() }
    cb(null, dispatch({type: 'add_estate_to_visible_list', estateId: estateId}))
  }
  const doFetchDirections = (cb) => cb(null, dispatch(fetchDirections(query, estateId)))
  const doFetchDetails = (cb) =>  cb(null, dispatch(fetchDetails(estateId)))

  auto({
    estateSummary: fetchSummaryIfNeeded,
    loadSummary: ['estateSummary', loadSummary],
    addToVisibleList: ['loadSummary', addToVisibleListIfNeeded],
    fetchDirections: doFetchDirections,
    fetchDetails: doFetchDetails,
  }, (err, results) => {
    if(err){
      return console.error("Failed to flip estate card", err)
    }
    dispatch({type: 'flip_estate_card', estateId})
  })
}




/** WEBPACK FOOTER **
 ** ./app/actions/flipEstateCard.js
 **/